import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import modules from './modules';
import dashboard from './modules/dashboard/dashboard';
import member from './modules/member/member';
import company from './modules/company/company';
import nonprofit from './modules/nonprofit/nonprofit';
import causes from './modules/causes/causes';
import cities from './modules/cities/cities';
import states from './modules/states/states';
import applicationTrackingSystem from './modules/applicationTrackingSystem/applicationTrackingSystem';
import searchAndDiscovery from './modules/searchAndDiscovery/searchAndDiscovery';
import events from './modules/events/events';
import createLogger from '../plugins/logger/logger';
import State from './state';
import memberInteriorSettings from './modules/memberInteriorSettings/memberInteriorSettings';

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store<State>({
  state: new State(),
  actions,
  getters,
  mutations,
  modules: {
    dashboard: {
      namespaced: true,
      ...dashboard
    },

    member: {    
      namespaced: true,
      ...member
    },

    company: {
      namespaced: true,
      ...company
    },

    nonprofit: {
      namespaced: true,
      ...nonprofit
    },

    causes: {
      namespaced: true,
      ...causes
    },

    cities: {
      namespaced: true,
      ...cities
    },
    
    states: {
      namespaced: true,
      ...states
    },

    events: {
     namespaced: true,
     ...events
    },

    applicationTrackingSystem: {
      namespaced: true,
      ...applicationTrackingSystem
    },

    searchAndDiscovery: {
      namespaced: true,
      ...searchAndDiscovery
    },

    memberInteriorSettings: {
      namespaced: true,
      ...memberInteriorSettings,
    }
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
})



// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/index.ts